/**
 * REWORKED Live Events - Client App v3
 * Flow: Customizer (size+designs+stamps) → Recap → Info → Vendor confirm → Payment → Ticket
 */

class LiveEventApp {
  constructor(opts) {
    this.configUrl = opts.configUrl;
    this.workerUrl = opts.workerUrl;
    this.config = null;
    this.state = { base: 'blanc', size: null, frontColor: null, backColor: null, stamps: [], promo: null };
    this.customer = {};
    this.assetBase = this.configUrl.substring(0, this.configUrl.lastIndexOf('/') + 1);
    this.dragging = null;
    this.init();
  }

  async init() {
    try {
      const resp = await fetch(this.configUrl);
      this.config = await resp.json();
    } catch (e) {
      console.error('Config failed:', e);
      this.toast('Erreur de chargement');
    }
  }

  assetUrl(f) { return this.assetBase + f + '?v=20260520'; }

  getMockupFile(face, base, color) {
    const b = base === 'noir' ? 'black' : 'white';
    return color ? 'mockup-' + face + '-' + b + '-' + (color === 'bleu' ? 'blue' : 'red') + '.jpg' : 'mockup-' + face + '-' + b + '-blank.jpg';
  }

  getStampFile(img, color) {
    if (!color || color === 'noir') return img;
    return img.replace('.svg', '-' + ({blanc:'white',bleu:'blue',rouge:'red'}[color] || color) + '.svg');
  }

  // ── NAVIGATION ──────────────────────────────────────────
  goTo(id) {
    document.querySelectorAll('.screen').forEach(s => s.classList.remove('active'));
    document.getElementById('scr-' + id)?.classList.add('active');
    window.scrollTo(0, 0);
    if (id === 'sizeSelect') this.renderSizeSelect();
    if (id === 'customizer') this.renderCustomizer();
    if (id === 'recap') this.renderRecap();
  }


  // ── SIZE SELECT (fullscreen) ─────────────────────────────
  renderSizeSelect() {
    const g = this.config.event.size_guide;
    const sizes = this.config.event.sizes;

    // Render size cards
    const grid = document.getElementById('sizeFullGrid');
    if (grid) {
      // Read stock from localStorage (shared with dashboard)
      const stockData = JSON.parse(localStorage.getItem('rw_stock_v2_' + this.config.event.id) || 'null') || this.config.event.stock;
      grid.innerHTML = sizes.map(s => {
        const m = g?.[s];
        const total = (stockData.blanc?.[s] || 0) + (stockData.noir?.[s] || 0);
        const lowStock = total > 0 && total <= 2;
        const outOfStock = total <= 0;
        return `<div class="size-full-card ${this.state.size === s ? 'selected' : ''} ${outOfStock ? 'out' : ''}" onclick="${outOfStock ? '' : "app.pickSize('" + s + "')"}">
          <div style="font-size:28px;font-weight:700">${s}</div>
          ${m ? `<div style="font-size:10px;color:var(--66);margin-top:4px">Poitrine ${m.chest}cm</div><div style="font-size:10px;color:var(--66)">Longueur ${m.length}cm</div>` : ''}
          ${lowStock ? '<div style="font-size:9px;color:#e65100;font-weight:700;margin-top:4px">STOCK BAS</div>' : ''}
          ${outOfStock ? '<div style="font-size:9px;color:var(--red);font-weight:700;margin-top:4px">RUPTURE</div>' : ''}
        </div>`;
      }).join('');
    }

    // Render guide table
    const tbody = document.getElementById('sizeGuideBody');
    if (tbody) {
      tbody.innerHTML = sizes.map(s => {
        const m = g?.[s];
        return `<tr style="border-bottom:1px solid #eee;${this.state.size === s ? 'background:#f0f0f0;font-weight:700' : ''}">
          <td style="padding:10px;font-weight:700">${s}</td>
          <td style="padding:10px;text-align:center">${m?.chest || '-'} cm</td>
          <td style="padding:10px;text-align:center">${m?.length || '-'} cm</td>
          <td style="padding:10px;text-align:center">${m?.sleeve || '-'} cm</td>
        </tr>`;
      }).join('');
    }

    // Enable/disable confirm button
    const btn = document.getElementById('sizeConfirmBtn');
    if (btn) {
      btn.style.opacity = this.state.size ? '1' : '0.3';
      btn.style.pointerEvents = this.state.size ? 'auto' : 'none';
    }
  }

  pickSize(s) {
    this.state.size = s;
    this.renderSizeSelect();
  }

  // ── PROMO CODE ──────────────────────────────────────────
  applyPromo() {
    const input = document.getElementById('promoInput');
    if (!input) return;
    const code = input.value.trim().toUpperCase();
    if (!code) return;

    // Known promo codes
    const promos = {
      'F&FRR': { type: 'free_stamps', label: 'Tampons offerts' },
    };

    const promo = promos[code];
    if (promo) {
      this.state.promo = { code, ...promo };
      this.toast('Code ' + code + ' applique : ' + promo.label);
    } else {
      this.state.promo = null;
      this.toast('Code invalide');
    }
    this.updatePrice();
    this.renderRecap();
  }

  // ── CUSTOMIZER ──────────────────────────────────────────
  renderCustomizer() {
    this.renderSizeSelector();
    this.renderBaseSection();
    this.renderDesignSection('front');
    this.renderDesignSection('back');
    this.renderStampsSection();
    this.updatePrice();
    this.updateMockups();
  }

  renderSizeSelector() {
    const container = document.getElementById('gridSize');
    if (!container) return;
    container.innerHTML = this.config.event.sizes.map(s => {
      const m = this.config.event.size_guide?.[s];
      return `<div class="size-card ${this.state.size === s ? 'selected' : ''}" onclick="app.selectSize('${s}')">
        <div class="size-letter">${s}</div>
        ${m ? `<div class="size-detail">${m.chest}x${m.length}cm</div>` : ''}
      </div>`;
    }).join('') +
    '<div class="size-card" onclick="app.showSizeGuide()" style="border-style:dashed;opacity:0.6"><div class="size-letter" style="font-size:14px">&#x1F4CF;</div><div class="size-detail">Guide</div></div>';
  }

  selectSize(s) {
    this.state.size = s;
    this.renderSizeSelector();
  }

  showSizeGuide() {
    const g = this.config.event.size_guide;
    let html = '<div style="padding:20px;max-width:400px;background:#fff;border-radius:14px;text-align:left"><h3 style="margin:0 0 12px;font-size:14px;letter-spacing:0.08em">GUIDE DES TAILLES</h3><p style="font-size:10px;color:#666;margin:0 0 12px">Coupe CROPPED (240 GSM) - Tolerance +/- 1 cm</p><table style="width:100%;font-size:11px;border-collapse:collapse">';
    html += '<tr style="border-bottom:2px solid #000"><th style="padding:6px;text-align:left">Taille</th><th>Poitrine</th><th>Longueur</th><th>Manche</th></tr>';
    for (const [s, m] of Object.entries(g)) {
      html += `<tr style="border-bottom:1px solid #eee${this.state.size === s ? ';background:#f0f0f0;font-weight:700' : ''}"><td style="padding:6px">${s}</td><td style="text-align:center">${m.chest} cm</td><td style="text-align:center">${m.length} cm</td><td style="text-align:center">${m.sleeve} cm</td></tr>`;
    }
    html += '</table></div>';
    this.zoomContent(html);
  }

  renderBaseSection() {
    const c = document.getElementById('gridBase');
    if (!c) return;
    c.innerHTML = ['blanc', 'noir'].map(color => `
      <div class="ds-card ${this.state.base === color ? 'selected' : ''}" onclick="app.setBase('${color}')">
        <div class="ds-thumb"><img src="${this.assetUrl(this.getMockupFile('front', color, null))}" style="width:100%;height:100%;object-fit:contain;border-radius:6px"></div>
        <div class="ds-name">${color === 'blanc' ? 'Blanc' : 'Noir'}</div>
      </div>
    `).join('');
  }

  setBase(c) { this.state.base = c; this.renderBaseSection(); this.updateMockups(); }

  renderDesignSection(face) {
    const c = document.getElementById(face === 'front' ? 'gridFront' : 'gridBack');
    const dc = face === 'front' ? this.config.front_design : this.config.back_design;
    const cur = face === 'front' ? this.state.frontColor : this.state.backColor;
    const colors = Object.entries(this.config.colors).filter(([k]) => k === 'bleu' || k === 'rouge');

    c.innerHTML = `<div class="ds-card ${!cur ? 'selected' : ''}" onclick="app.selectDesignColor('${face}',null)">
      <div class="ds-thumb" style="opacity:0.3"><img src="${this.assetUrl(this.getMockupFile(face, this.state.base, null))}" style="width:100%;height:100%;object-fit:contain;border-radius:6px"></div>
      <div class="ds-name">Aucun</div>
    </div>` + colors.map(([k, col]) => `<div class="ds-card ${cur === k ? 'selected' : ''}" onclick="app.selectDesignColor('${face}','${k}')">
      <div class="ds-thumb"><img src="${this.assetUrl(dc.images[k])}" style="width:100%;height:100%;object-fit:contain"></div>
      <div class="ds-name">${col.label}</div>
      <div class="ds-zoom" onclick="event.stopPropagation();app.zoomDesign('${this.assetUrl(dc.images[k])}')">&#x1F50D;</div>
    </div>`).join('');
  }

  selectDesignColor(face, c) {
    if (face === 'front') this.state.frontColor = c; else this.state.backColor = c;
    this.renderDesignSection(face);
    this.updatePrice();
    this.updateMockups();
  }

  renderStampsSection() {
    const c = document.getElementById('gridStamp');
    const stampColors = ['noir', 'blanc', 'bleu', 'rouge'];
    c.innerHTML = this.config.stamps.map(s => {
      const added = this.state.stamps.find(st => st.id === s.id);
      const ac = added ? added.color : null;
      return `<div class="stamp-card ${added ? 'selected' : ''}" onclick="app.toggleStamp('${s.id}')">
        <div class="stamp-preview"><img src="${this.assetUrl(this.getStampFile(s.image, ac))}" style="width:100%;height:100%;object-fit:contain"></div>
        <div class="stamp-name">${s.name}</div>
        <div class="stamp-colors">${stampColors.map(col => {
          const hex = this.config.colors[col].hex;
          const brd = col === 'blanc' ? '1px solid #ccc' : col === 'noir' ? '1px solid #333' : 'none';
          return `<div class="color-dot ${ac === col ? 'active' : ''}" style="background:${hex};border:${brd}" onclick="event.stopPropagation();app.setStampColor('${s.id}','${col}')"></div>`;
        }).join('')}</div>
        ${added ? '<div class="stamp-price">+' + this.config.event.stamp_price + ' EUR</div>' : ''}
        <div class="ds-zoom" onclick="event.stopPropagation();app.zoomDesign('${this.assetUrl(this.getStampFile(s.image, ac))}')">&#x1F50D;</div>
      </div>`;
    }).join('');
  }

  toggleStamp(id) {
    const i = this.state.stamps.findIndex(s => s.id === id);
    if (i >= 0) this.state.stamps.splice(i, 1);
    else this.state.stamps.push({ id, color: 'noir', face: 'front', px: 30 + Math.random() * 40, py: 30 + Math.random() * 30 });
    this.renderStampsSection();
    this.updatePrice();
    this.renderStampOverlays();
  }

  setStampColor(id, c) {
    let s = this.state.stamps.find(st => st.id === id);
    if (!s) this.state.stamps.push({ id, color: c, x: 25 + Math.random() * 20, y: 30 + Math.random() * 40 });
    else s.color = c;
    this.renderStampsSection();
    this.renderStampOverlays();
  }

  // ── PRICE ───────────────────────────────────────────────
  calcPrice() {
    const ev = this.config.event;
    let stampCost = this.state.stamps.length * ev.stamp_price;
    let discount = 0;
    if (this.state.promo?.type === 'free_stamps') {
      discount = stampCost;
      stampCost = 0;
    }
    return { base: ev.base_price, stamps: this.state.stamps.length * ev.stamp_price, discount, total: ev.base_price + stampCost };
  }

  updatePrice() {
    const p = this.calcPrice();
    const c = this.config.event.currency;
    document.getElementById('totalDisplay').textContent = p.total + ' ' + c;
    document.getElementById('custPriceTop').textContent = p.total + ' ' + c;
    document.getElementById('basePriceDisplay').textContent = p.base + ' ' + c;
    const er = document.getElementById('extrasRow');
    const stampCount = this.state.stamps.length;
    if (stampCount > 0) {
      er.style.display = 'flex';
      if (p.discount > 0) {
        document.getElementById('extrasDisplay').innerHTML = '<s>+' + (stampCount * this.config.event.stamp_price) + ' ' + c + '</s> <span style="color:#2e7d32">OFFERTS</span>';
      } else {
        document.getElementById('extrasDisplay').textContent = '+' + p.stamps + ' ' + c + ' (' + stampCount + ' tampon' + (stampCount > 1 ? 's' : '') + ')';
      }
    } else er.style.display = 'none';
  }

  // ── MOCKUPS ─────────────────────────────────────────────
  updateMockups() {
    const fp = document.getElementById('mockupFrontPhoto');
    const bp = document.getElementById('mockupBackPhoto');
    if (fp) fp.src = this.assetUrl(this.getMockupFile('front', this.state.base, this.state.frontColor));
    if (bp) bp.src = this.assetUrl(this.getMockupFile('back', this.state.base, this.state.backColor));
    this.renderStampOverlays();
  }

  // ── STAMP OVERLAYS (positioned per-photo, draggable) ─────
  renderStampOverlays() {
    // Place stamps inside individual mockup-body containers
    const frontBody = document.getElementById('mockupFrontPhoto')?.parentElement;
    const backBody = document.getElementById('mockupBackPhoto')?.parentElement;
    if (!frontBody || !backBody) return;
    frontBody.style.position = 'relative';
    backBody.style.position = 'relative';

    // Remove old
    [frontBody, backBody].forEach(b => b.querySelectorAll('.stamp-overlay').forEach(el => el.remove()));

    this.state.stamps.forEach(s => {
      const sc = this.config.stamps.find(st => st.id === s.id);
      if (!sc) return;
      // Default face to front if not set
      if (!s.face) s.face = 'front';
      const body = s.face === 'front' ? frontBody : backBody;
      const sizePct = (sc.size_cm || 5) * 1.1; // % of photo width

      const el = document.createElement('div');
      el.className = 'stamp-overlay';
      el.dataset.stampId = s.id;
      el.style.cssText = `position:absolute;left:${s.px || 50}%;top:${s.py || 50}%;transform:translate(-50%,-50%);width:${sizePct}%;cursor:grab;touch-action:none;z-index:10`;
      el.innerHTML = `<img src="${this.assetUrl(this.getStampFile(sc.image, s.color))}" style="width:100%;height:auto" draggable="false">`;
      el.addEventListener('touchstart', e => this.startDrag(e, s.id), { passive: false });
      el.addEventListener('mousedown', e => this.startDrag(e, s.id));
      body.appendChild(el);
    });
  }

  startDrag(e, id) {
    e.preventDefault(); e.stopPropagation();
    const s = this.state.stamps.find(st => st.id === id);
    if (!s) return;
    const el = e.currentTarget;
    el.style.cursor = 'grabbing';

    const frontBody = document.getElementById('mockupFrontPhoto')?.parentElement;
    const backBody = document.getElementById('mockupBackPhoto')?.parentElement;

    const mv = ev => {
      const cx = ev.touches ? ev.touches[0].clientX : ev.clientX;
      const cy = ev.touches ? ev.touches[0].clientY : ev.clientY;

      // Determine which photo the stamp is over
      const fr = frontBody.getBoundingClientRect();
      const br = backBody.getBoundingClientRect();
      const overFront = cx >= fr.left && cx <= fr.right && cy >= fr.top && cy <= fr.bottom;
      const overBack = cx >= br.left && cx <= br.right && cy >= br.top && cy <= br.bottom;

      let targetBody, targetFace;
      if (overBack) { targetBody = backBody; targetFace = 'back'; }
      else { targetBody = frontBody; targetFace = 'front'; } // default to front

      const r = targetBody.getBoundingClientRect();
      s.px = Math.round(Math.max(5, Math.min(95, ((cx - r.left) / r.width) * 100)));
      s.py = Math.round(Math.max(5, Math.min(95, ((cy - r.top) / r.height) * 100)));

      // Move to other photo if needed
      if (s.face !== targetFace) {
        s.face = targetFace;
        el.remove();
        targetBody.appendChild(el);
      }

      el.style.left = s.px + '%';
      el.style.top = s.py + '%';
    };

    const up = () => {
      el.style.cursor = 'grab';
      document.removeEventListener('touchmove', mv);
      document.removeEventListener('touchend', up);
      document.removeEventListener('mousemove', mv);
      document.removeEventListener('mouseup', up);
    };
    document.addEventListener('touchmove', mv, { passive: false });
    document.addEventListener('touchend', up);
    document.addEventListener('mousemove', mv);
    document.addEventListener('mouseup', up);
  }

  // ── STAMPS ON MOCKUP PAIR (recap/vendor) ────────────────
  renderStampsOnMockup(fId, bId) {
    const fb = document.getElementById(fId);
    const bb = document.getElementById(bId);
    if (!fb || !bb) return;
    [fb, bb].forEach(b => b.querySelectorAll('.stamp-on-mockup').forEach(el => el.remove()));
    this.state.stamps.forEach(s => {
      const sc = this.config.stamps.find(st => st.id === s.id);
      if (!sc) return;
      const isFront = s.x < 50;
      const body = isFront ? fb : bb;
      const lx = isFront ? s.x * 2 : (s.x - 50) * 2;
      const pct = (['stamp-1','stamp-3','stamp-6'].includes(s.id)) ? 18 : 10;
      const el = document.createElement('div');
      el.className = 'stamp-on-mockup';
      el.style.cssText = `position:absolute;left:${lx}%;top:${s.y}%;transform:translate(-50%,-50%);width:${pct}%;z-index:5;pointer-events:none`;
      el.innerHTML = `<img src="${this.assetUrl(this.getStampFile(sc.image, s.color))}" style="width:100%;height:auto">`;
      body.appendChild(el);
    });
  }

  // ── RECAP ───────────────────────────────────────────────
  renderRecap() {
    const p = this.calcPrice();
    const c = this.config.event.currency;
    document.getElementById('recapPriceTop').textContent = p.total + ' ' + c;

    // Place stamps on recap photos (same face/px/py as customizer)
    const rfb = document.getElementById('recapFrontBody');
    const rbb = document.getElementById('recapBackBody');
    if (rfb && rbb) {
      // Set photos
      const rfp = rfb.querySelector('img');
      const rbp = rbb.querySelector('img');
      if (rfp) rfp.src = this.assetUrl(this.getMockupFile('front', this.state.base, this.state.frontColor));
      if (rbp) rbp.src = this.assetUrl(this.getMockupFile('back', this.state.base, this.state.backColor));
      // Remove old stamps
      [rfb, rbb].forEach(b => b.querySelectorAll('.stamp-on-recap').forEach(el => el.remove()));
      // Place stamps
      this.state.stamps.forEach(s => {
        const sc = this.config.stamps.find(st => st.id === s.id);
        if (!sc) return;
        const body = s.face === 'back' ? rbb : rfb;
        const sizePct = (sc.size_cm || 5) * 1.1;
        const el = document.createElement('div');
        el.className = 'stamp-on-recap';
        el.style.cssText = `position:absolute;left:${s.px || 50}%;top:${s.py || 50}%;transform:translate(-50%,-50%);width:${sizePct}%;pointer-events:none;z-index:5`;
        el.innerHTML = `<img src="${this.assetUrl(this.getStampFile(sc.image, s.color))}" style="width:100%;height:auto">`;
        body.appendChild(el);
      });
    }

    let items = '';
    items += this.rr('Base', this.state.base === 'noir' ? 'Noir' : 'Blanc');
    items += this.rr('Taille', this.state.size || 'Non choisie');
    items += this.rr('Design avant', this.state.frontColor ? this.config.colors[this.state.frontColor].label : 'Aucun');
    items += this.rr('Design arriere', this.state.backColor ? this.config.colors[this.state.backColor].label : 'Aucun');
    this.state.stamps.forEach(s => {
      const sc = this.config.stamps.find(st => st.id === s.id);
      items += this.rr(sc?.name || s.id, this.config.colors[s.color]?.label + ' (+' + this.config.event.stamp_price + ' ' + c + ')');
    });
    document.getElementById('recapItems').innerHTML = items;
    let totalHtml = this.rr('T-shirt', p.base + ' ' + c);
    if (this.state.stamps.length > 0) {
      if (p.discount > 0) {
        totalHtml += this.rr('Tampons (' + this.state.stamps.length + ')', '<s>+' + p.stamps + ' ' + c + '</s> <span style="color:#2e7d32;font-weight:700">OFFERTS</span>');
      } else {
        totalHtml += this.rr('Tampons (' + this.state.stamps.length + ')', '+' + p.stamps + ' ' + c);
      }
    }
    if (this.state.promo) totalHtml += this.rr('Code promo', '<span style="color:#2e7d32">' + this.state.promo.code + '</span>');
    totalHtml += `<div class="recap-row total"><span class="label">Total TTC</span><span class="value">${p.total} ${c}</span></div>`;
    document.getElementById('recapTotalSection').innerHTML = totalHtml;
  }

  rr(l, v) { return `<div class="recap-row"><span class="label">${l}</span><span class="value">${v}</span></div>`; }

  // ── INFO FORM ───────────────────────────────────────────
  submitInfo(e) {
    e.preventDefault();
    if (!this.state.size) { this.toast('Choisissez une taille dans le personnalisateur'); return false; }
    this.customer = {
      firstName: document.getElementById('inputFirstName').value,
      lastName: document.getElementById('inputLastName').value,
      email: document.getElementById('inputEmail').value,
      phone: document.getElementById('inputPhone').value,
      size: this.state.size,
      notes: document.getElementById('inputNotes').value,
    };
    // Update payment screen price
    const p = this.calcPrice();
    const payDisplay = document.getElementById('payTotalDisplay');
    if (payDisplay) payDisplay.textContent = p.total + ' ' + this.config.event.currency;
    this.goTo('vendorConfirm');
    return false;
  }

  // ── ORDER SUBMISSION → WORKER → DRAFT ORDER ────────────
  async submitOrder(paymentMethod) {
    const p = this.calcPrice();
    const ev = this.config.event;
    const stampsDesc = this.state.stamps.map(s => {
      const sc = this.config.stamps.find(st => st.id === s.id);
      const cl = this.config.colors[s.color]?.label || s.color;
      const side = s.face === 'back' ? 'AR' : 'AV';
      return (sc?.name || s.id) + ' ' + cl + ' [' + side + ']';
    }).join(', ') || 'Aucun';

    const orderData = {
      event: ev.id, event_name: ev.name,
      customer: this.customer,
      designs: {
        base: this.state.base, base_name: 'T-shirt ' + (this.state.base === 'noir' ? 'Noir' : 'Blanc'),
        front_color: this.state.frontColor,
        front_name: this.state.frontColor ? 'Design Avant - ' + this.config.colors[this.state.frontColor].label : 'Aucun',
        back_color: this.state.backColor,
        back_name: this.state.backColor ? 'Design Arriere - ' + this.config.colors[this.state.backColor].label : 'Aucun',
        stamps: stampsDesc, stamps_detail: this.state.stamps,
      },
      price: p.total, currency: ev.currency, payment_method: paymentMethod,
      promo_code: this.state.promo?.code || null,
    };

    document.querySelectorAll('.pay-card').forEach(c => { c.style.opacity = '0.5'; c.style.pointerEvents = 'none'; });
    try {
      const resp = await fetch(this.workerUrl + '/order', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(orderData) });
      const result = await resp.json();
      if (result.success) {
        this.renderConfirmation(result, orderData);
        this.goTo('confirm');
        this.toast('Commande ' + result.name + ' enregistree !');
      } else {
        this.toast('Erreur: ' + (result.error || 'Reessayez'));
        document.querySelectorAll('.pay-card').forEach(c => { c.style.opacity = '1'; c.style.pointerEvents = 'auto'; });
      }
    } catch (err) {
      this.toast('Erreur de connexion');
      document.querySelectorAll('.pay-card').forEach(c => { c.style.opacity = '1'; c.style.pointerEvents = 'auto'; });
    }
  }

  // ── CONFIRMATION ────────────────────────────────────────
  renderConfirmation(result, order) {
    document.getElementById('confOrderId').textContent = result.name;
    document.getElementById('ticketBody').innerHTML = [
      this.tr('N Commande', result.name),
      this.tr('Date', new Date().toLocaleDateString('fr-FR')),
      this.tr('Heure', new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })),
      this.tr('Client', order.customer.firstName + ' ' + order.customer.lastName),
      this.tr('Taille', order.customer.size),
      this.tr('Base', order.designs.base_name),
      this.tr('Avant', order.designs.front_name),
      this.tr('Arriere', order.designs.back_name),
      this.tr('Tampons', order.designs.stamps),
      this.tr('Paiement', order.payment_method === 'cash' ? 'Especes' : 'CB'),
      `<div class="ticket-row total"><span class="label">TOTAL TTC</span><span class="value">${order.price} ${order.currency}</span></div>`,
    ].join('');

    // Setup send ticket buttons
    const email = order.customer.email;
    const phone = order.customer.phone;
    const sendArea = document.getElementById('sendTicketArea');
    if (sendArea) {
      sendArea.innerHTML = email
        ? `<button class="btn btn-s btn-p" onclick="app.sendTicket('${email}','${result.name}')">Envoyer le ticket par email</button>`
        : '<div style="font-size:10px;color:var(--99)">Aucun email renseigne</div>';
    }
  }

  tr(l, v) { return `<div class="ticket-row"><span class="label">${l}</span><span class="value">${v}</span></div>`; }

  sendTicket(email, orderName) {
    const rows = document.getElementById('ticketBody')?.innerText || '';
    const subject = 'REWORKED - Votre commande ' + orderName;
    const body = 'Bonjour,\n\nMerci pour votre commande lors de l\u2019\u00e9v\u00e8nement RAWRUN PARTY !\nVoici le r\u00e9capitulatif de votre commande :\n\n\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\n' + rows + '\n\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\n\nVotre t-shirt a \u00e9t\u00e9 s\u00e9rigraphi\u00e9 en direct par REWORKED.\n\nPour toute question :\nEmail : contact@rework-ed.com\nInstagram : @rework__ed\nSite : rework-ed.com\n\n\u00c0 bient\u00f4t !\nL\u2019\u00e9quipe REWORKED';

    window.open('mailto:' + email + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body));
    this.toast('Email ouvert pour ' + email);
  }

  // ── RESET ───────────────────────────────────────────────
  reset() {
    this.state = { base: 'blanc', size: null, frontColor: null, backColor: null, stamps: [], promo: null };
    this.customer = {};
    document.querySelectorAll('.stamp-overlay').forEach(el => el.remove());
    document.getElementById('infoForm')?.reset();
    document.querySelectorAll('.pay-card').forEach(c => { c.style.opacity = '1'; c.style.pointerEvents = 'auto'; });
    this.goTo('welcome');
  }

  // ── MOCKUP ZOOM (customizer) ─────────────────────────────
  zoomMockup(face) {
    // Don't zoom if a stamp was just dragged
    if (this._justDragged) { this._justDragged = false; return; }
    const frontBody = document.getElementById('mockupFrontBody');
    const backBody = document.getElementById('mockupBackBody');
    if (face === 'both') {
      this._showZoomModal([frontBody, backBody], ['AVANT', 'ARRIERE']);
    } else {
      const body = face === 'front' ? frontBody : backBody;
      this._showZoomModal([body], [face === 'front' ? 'AVANT' : 'ARRIERE']);
    }
  }

  // ── RECAP ZOOM ──────────────────────────────────────────
  zoomRecap(face) {
    const frontBody = document.getElementById('recapFrontBody');
    const backBody = document.getElementById('recapBackBody');
    if (face === 'both') {
      this._showZoomModal([frontBody, backBody], ['AVANT', 'ARRIERE']);
    } else {
      const body = face === 'front' ? frontBody : backBody;
      this._showZoomModal([body], [face === 'front' ? 'AVANT' : 'ARRIERE']);
    }
  }

  _showZoomModal(bodies, labels) {
    let m = document.getElementById('zoomModal');
    if (!m) {
      m = document.createElement('div');
      m.id = 'zoomModal';
      m.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.92);z-index:9999;display:flex;align-items:center;justify-content:center;gap:16px;padding:20px;flex-wrap:wrap';
      m.onclick = e => { if (e.target === m) m.style.display = 'none'; };
      document.body.appendChild(m);
    }
    m.innerHTML = '<div style="position:absolute;top:12px;right:16px;color:#fff;font-size:28px;cursor:pointer" onclick="this.parentElement.style.display=\'none\'">&times;</div>';

    bodies.forEach((body, i) => {
      if (!body) return;
      const clone = body.cloneNode(true);
      clone.style.cssText = 'position:relative;display:inline-block;max-width:' + (bodies.length > 1 ? '45vw' : '80vw') + ';max-height:85vh;background:#fff;border-radius:12px;padding:8px';
      const img = clone.querySelector('img');
      if (img) img.style.cssText = 'width:100%;max-height:80vh;object-fit:contain;border-radius:8px;display:block';
      // Scale stamp overlays for visibility
      clone.querySelectorAll('.stamp-overlay,.stamp-on-recap').forEach(s => {
        s.style.cursor = 'default';
        s.style.touchAction = 'auto';
      });
      const wrapper = document.createElement('div');
      wrapper.style.cssText = 'position:relative;text-align:center';
      wrapper.appendChild(clone);
      const label = document.createElement('div');
      label.style.cssText = 'color:#fff;font-size:10px;font-weight:700;letter-spacing:0.08em;margin-top:6px';
      label.textContent = labels[i] || '';
      wrapper.appendChild(label);
      m.appendChild(wrapper);
    });

    m.style.display = 'flex';
  }

  // ── ZOOM ───────────────────────────────────────────────
  zoomDesign(url) {
    this.zoomContent(`<img src="${url}" style="max-width:min(400px,70vw);max-height:min(400px,70vh);object-fit:contain;background:#fff;padding:16px;border-radius:10px">`);
  }

  zoomContent(html) {
    let m = document.getElementById('zoomModal');
    if (!m) { m = document.createElement('div'); m.id = 'zoomModal'; m.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.85);z-index:9999;display:flex;align-items:center;justify-content:center;padding:20px;cursor:pointer'; m.onclick = () => m.style.display = 'none'; document.body.appendChild(m); }
    m.innerHTML = html; m.style.display = 'flex';
  }

  toast(msg) {
    const c = document.getElementById('toastContainer');
    const el = document.createElement('div');
    el.className = 'toast'; el.textContent = msg; c.appendChild(el);
    setTimeout(() => { el.style.opacity = '0'; setTimeout(() => el.remove(), 200); }, 3000);
  }
}
